module.exports = __webpack_public_path__ + "static/media/power_clean-01.27325d53.png";